<div (click)="openCart()" class="kart" >
    <span class="iconfa">
        <fa-icon [icon]="faShoppingCart"></fa-icon>
    </span>
</div>